import React from 'react'

const ProgressBar = ({ progress }: { progress: React.CSSProperties }) => {
  return (
    <div
      role='progressbar'
      className='absolute  bg-secondary -inset-[2px] flex items-center justify-center z-10 h-[5px] rounded-t-[10px]'
    >
      <div className='h-[5px] w-full absolute top-0 bg-secondary overflow-hidden rounded-t-[10px] '>
        <div
          className='h-full bg-gradient-to-tr from-[#FB0E00] to-[#00219F] '
          style={progress}
        ></div>
      </div>
    </div>
  )
}

export default ProgressBar
